<template>
  <div>
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      min-width="auto"
      hide-details
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="computedDateFormatted"
          prepend-inner-icon="mdi-calendar-month"
          label="Ngày sinh"
          readonly
          outlined
          v-bind="attrs"
          v-on="on"
          :disabled="disabled"
          hide-details
          clearable
        />
      </template>
      <v-date-picker
        v-model="date"
        :active-picker.sync="activePicker"
        hide-details
        locale="vi"
        :max="
          new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10)
        "
        color="#FBB040"
        min="1950-01-01"
        no-title
        @change="save"
      />
    </v-menu>
  </div>
</template>

<script>
import { EMPTY } from "~/utils/constants";
import { parseDate, formatDate } from "~/utils";

export default {
  name: "BirthdayPicker",
  props: {
    label: {
      type: String,
      default: EMPTY,
    },
    value: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    activePicker: null,
    date: null,
    menu: false,
  }),
  computed: {
    computedDateFormatted() {
      return formatDate(this.date);
    },
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
    value: {
      handler(newVal) {
        this.date = parseDate(newVal);
      },
      immediate: true,
    },
  },
  methods: {
    save(date) {
      this.$refs.menu.save(date);
      this.$emit("input", this.computedDateFormatted);
    },
  },
};
</script>
